import React from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';

import CopyDialog from './CopyDialog';

function Editor (props) {
    const { form } = props;
    const handleCopy = ({ urlFormId }) => {
        const { history, basePath } = props;
        history.push(`${basePath}/${urlFormId}/edit`);
    };

    return (
        <CopyDialog
            handleCopy={handleCopy}
            form={form}
        />
    );
}

const mapStateToProps = state => ({
    form: state.formEditor.form,
    basePath: state.path.basePath
});

export default compose(
    withRouter,
    connect(mapStateToProps)
)(Editor);
